import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/boule-paille.svg';
import { mapGetters } from 'vuex';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  layout: 'default',
  props: {
    error: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    url: function url() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/");
    },
    title: function title() {
      if (this.error.statusCode === 404) {
        return this.$t('title');
      }

      if (this.error.statusCode === 500) {
        return this.$t('title500');
      }

      return '';
    },
    message: function message() {
      if (this.error.statusCode === 404) {
        return this.$t('notfound');
      }

      if (this.error.statusCode === 500) {
        return this.$t('error500');
      }

      return '';
    },
    image: function image() {
      if (this.error.statusCode === 404) {
        return 'https://cdn.maisonsdumonde.com/medias/errors/404/cactus.png';
      }

      if (this.error.statusCode === 500) {
        return 'https://cdn.maisonsdumonde.com/medias/errors/500/dog.gif';
      }

      return EMPTY_PIXEL;
    }
  }),
  mounted: function mounted() {
    if (this.$cookies.get('debugmdm')) {
      console.error(this.error);
    }
  }
};